import { useState } from 'react';

import { copierPressePapiers } from '../lib/divers';
import { Bouton } from './Boutons';

/**
 * Affichage d'une charge utile brute (trame d'objet, `avant`/`après` d'une entrée d'audit).
 *
 * Le back-office ne cherche pas à embellir ces données : leur valeur de diagnostic tient à ce
 * qu'elles soient montrées TELLES QUE reçues. Le seul confort ajouté est la copie en un clic,
 * pour coller la trame dans un ticket ou la rejouer.
 */
export function JsonBrut({
  valeur,
  libelleCopie = 'Copier',
}: {
  valeur: unknown;
  libelleCopie?: string;
}): JSX.Element {
  const [copie, setCopie] = useState(false);
  const texte = JSON.stringify(valeur, null, 2);

  return (
    <div className="gv-pile gv-pile--serree">
      <div className="gv-ligne">
        <Bouton
          petit
          variante="discret"
          onClick={() => {
            void copierPressePapiers(texte).then((ok) => {
              setCopie(ok);
              if (ok) window.setTimeout(() => { setCopie(false); }, 2000);
            });
          }}
        >
          {copie ? 'Copié' : libelleCopie}
        </Bouton>
      </div>
      <pre className="gv-json">{texte}</pre>
    </div>
  );
}
